<div class="main-content side-content pt-0 ml-0">
  <div class="main-container container-fluid">
    <div class="inner-body">
      <div class="row row-sm add-form">
        <div class="col-lg-12 col-md-12">
          <div class="card custom-card">
            <div class="card-body pb-0">
              <div class="col-md-12 prpl">
                <div class="row align-items-center mb-3">
                  <div class="col-md-10">
                    <div class="d-flex align-items-center">
                      <img
                        alt="Logo"
                        src="../../assets/img/attendance.png"
                        class="mh-45px pb-2"
                      />
                      <p class="mb-1 ml-3"> 
                        <span class="main-content-label f600"
                          ><b>Theory Exam Appointment Report</b></span
                        ><br />
                        <span class="text-muted card-sub-title mb-0"
                          >View and Print Theory Exam Appointments</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <hr class="mt-2" />

                <form [formGroup]="reportForm" autocomplete="off">
                  <!-- Filters Row 1 -->
                  <div class="row clearfix mt-2">
                    <!-- Session Dropdown -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field
                          appearance="outline"
                          class="example-full-width"
                        >
                          <mat-label>Session</mat-label>
                          <mat-select
                            formControlName="SessionId"
                            (selectionChange)="onSessionChange($event.value)"
                          >
                            <mat-option
                              *ngFor="let item of sessionList"
                              [value]="item.SnNo"
                            >
                              {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="f.SessionId.hasError('required')"
                            >Session is required</mat-error
                          >
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Faculty Dropdown (MULTI-SELECT with Select All) -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Faculty</mat-label>
                          <mat-select formControlName="FacultyId" multiple
                            (selectionChange)="onFacultyChange($event.value)">
                            <!-- Select All option -->
                            <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                              Select All
                            </mat-option>
                            <mat-option *ngIf="facultyList.length === 0" disabled>
                              No faculties available
                            </mat-option>
                            <mat-option *ngFor="let item of facultyList" [value]="item.FcCode">
                              {{ item.FcCode }} - {{ item.FcDesc }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Course Level Dropdown (MULTI-SELECT with Select All) -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course Level</mat-label>
                          <mat-select formControlName="CourseLevel" multiple
                            (selectionChange)="onCourseLevelChange($event.value)">
                            <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                              Select All
                            </mat-option>
                            <mat-option *ngFor="let item of courseLevelList" [value]="item.CdCode">
                              {{ item.CdDesc }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Course Dropdown (Multi-select) -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select formControlName="Course" multiple (selectionChange)="onCourseChange($event.value)">
                            <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                              Select All
                            </mat-option>
                            <mat-option *ngIf="filteredCourseList.length === 0" disabled>
                              No courses available
                            </mat-option>
                            <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode">
                              {{ item.CoCgCoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="f.Course.hasError('required')">Course is required</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Exam Dropdown (Multi-select) -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select formControlName="Exam" multiple (selectionChange)="onExamChange($event.value)">
                            <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                              Select All
                            </mat-option>
                            <mat-option *ngIf="filteredExamList.length === 0" disabled>
                              No exams available
                            </mat-option>
                            <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                              {{ item.EmCoCode }} - {{ item.EmName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="f.Exam.hasError('required')">Exam is required</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Center Dropdown -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field
                          appearance="outline"
                          class="example-full-width"
                        >
                          <mat-label>Center</mat-label>
                          <mat-select
                            formControlName="Center"
                            (selectionChange)="onCenterChange()"
                          >
                            <mat-option *ngFor="let item of collegeList" [value]="item.CgCode">
                              {{ item.CgCode }} - {{ item.CgName }} ({{ item.DistrictName }})
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="f.Center.hasError('required')">Center is required</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Role Dropdown -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <mat-form-field
                          appearance="outline"
                          class="example-full-width"
                        >
                          <mat-label>Role</mat-label>
                          <mat-select
                            formControlName="Role"
                            (selectionChange)="onRoleChange()"
                          >
                            <mat-option
                              *ngFor="let item of roleList"
                              [value]="item.CdCode"
                            >
                              {{ item.CdDesc }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Appointment Type -->
                    <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                      <div class="form-group">
                        <label class="d-block">Appointment Type :</label>
                        <mat-radio-group formControlName="ApptType" class="d-flex" (change)="onApptTypeChange()">
                          <mat-radio-button value="R" class="mr-3">Regular</mat-radio-button>
                          <mat-radio-button value="X">Emergency Replacement</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                </form>

                <!-- Action Buttons -->
                <div class="col-sm-12 mt-4 mb-3">
                  <div class="floatright">
                    <button
                      type="button"
                      class="btn size1 btn-primary btn-icon-text mr-3"
                      [disabled]="
                        !reportForm.get('Role')?.value ||
                        appointmentsList.length === 0
                      "
                      (click)="onPrintLetter()"
                    >
                      <i class="fas fa-print"></i>
                      <span class="ml-1">Print</span>
                    </button>
                    <button
                      type="button"
                      class="btn size1 btn-primary btn-icon-text"
                      (click)="onClear()"
                    >
                      <i class="fas fa-undo-alt"></i>
                      <span class="ml-1">Clear</span>
                    </button>
                  </div>
                </div>
                <hr class="mt-3" />

                <!-- Results Table -->
                <div
                  *ngIf="showTable"
                  class="table-responsive mt-4"
                  id="printSection"
                >
                  <div class="container-fluid pl-pr">
                    <!-- Report Header for Print -->
                    <div
                      class="print-header text-center mb-4"
                      style="display: none"
                    >
                      <h3>Theory Exam Appointment Report</h3>
                      <p>
                        Generated on:
                        {{ currentDateTime | date: "dd/MM/yyyy hh:mm a" }}
                      </p>
                      <hr />
                    </div>

                    <table class="table table-bordered text-center">
                      <thead class="text-center">
                        <tr>
                          <th style="min-width: 50px">#</th>
                          <th style="min-width: 200px">Teacher Name</th>
                          <th style="min-width: 120px">Role</th>
                          <th style="min-width: 120px">From Date</th>
                          <th style="min-width: 120px">To Date</th>
                          <th style="min-width: 150px">Session</th>
                          <th style="min-width: 150px">Faculty</th>
                          <th style="min-width: 120px">Course Level</th>
                          <th style="min-width: 150px">Course</th>
                          <th style="min-width: 150px">Exam</th>
                          <th style="min-width: 150px">Center</th>
                          <th style="min-width: 100px">Appointment Type</th> 
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let item of appointmentsList; let i = index"
                        >
                          <td>{{ i + 1 }}</td>
                          <td class="tdleft">{{ item.TeacherName || "-" }}</td>
                          <td class="tdleft">
                            {{ item.RoleName || item.RoleCode || "-" }}
                          </td>
                          <td class="tdleft">{{ item.FromDate || "-" }}</td>
                          <td class="tdleft">{{ item.ToDate || "-" }}</td>
                          <td class="tdleft">{{ item.SessionName || "-" }}</td>
                          <td class="tdleft">{{ item.FacultyName || "-" }}</td>
                          <td class="tdleft">{{ item.CourseLevel || "-" }}</td>
                          <td class="tdleft">{{ item.CourseName || "-" }}</td>
                          <td class="tdleft">{{ item.ExamName || "-" }}</td>
                          <td class="tdleft">{{ item.CenterName || "-" }}</td>
                          <td class="tdleft">
                            <span *ngIf="item.ApptType === 'R'">Regular</span>
                            <span *ngIf="item.ApptType === 'X'">Emergency Replacement</span>
                            <span *ngIf="!item.ApptType">-</span>
                          </td>
                        </tr>
                        <tr *ngIf="appointmentsList.length === 0">
                          <td colspan="12" class="text-center"> 
                            <i class="fas fa-info-circle mr-2"></i>
                            No appointments found. Please select filters to view
                            data.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>